import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, Checkbox } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { DashboardRoute } from "@/routes/dashboard";
import AppContext from "@/App/context/AppContext";
import { PostRequest } from "@/api/RequestTemplates";
import { useMutation, useQueryClient } from "react-query";

async function getImpersonateToken(targetUserId: string) {
  const response = await PostRequest(
    `${process.env.API_SERVER_URL}/impersonationtoken`,
    new URLSearchParams({
      targetUserId,
    })
  );
  return response;
}

function Impersonate() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const searchParams = new URLSearchParams(search);
  const name = searchParams.get("name");
  const targetUserId = searchParams.get("userId");
  const { setLoggedIn, setImpersonatorToken } = useContext(AppContext);
  const queryClient = useQueryClient();

  const [isChecked, setIsChecked] = useState(false);

  const mutation = useMutation((targetUserId: string | undefined) => getImpersonateToken(targetUserId ?? ""), {
    onSuccess: (data) => {
      switchUser(data);
      setTimeout(() => {
        queryClient.invalidateQueries("userQuery");
      }, 500);
    },
  });

  const handleSubmit = () => {
    mutation.mutate(targetUserId ?? undefined);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const switchUser = (data: any) => {
    const afterLoginRedirectUrl = searchParams.get("afterLoginRedirectURL")?.replace(/"/g, "");
    setLoggedIn && setLoggedIn(false);
    const accessToken = localStorage.getItem("access_token");
    const keysToDelete = [
      "access_token",
      "auto_login_token",
      "client_id",
      "expires_in",
      "gtmInitialized",
      "jti",
      "refresh_token",
      "scope",
      "token_type",
      "user_id",
    ];
    keysToDelete.forEach((key) => {
      localStorage.removeItem(key);
    });

    const datatemp = data.data;

    // Iterate over the key-value pairs in the data object and set them in localStorage
    for (const [key, value] of Object.entries(datatemp)) {
      localStorage.setItem(key, String(value));
    }
    localStorage.setItem("impersonator_token", accessToken ?? "");
    setImpersonatorToken && setImpersonatorToken(accessToken ?? "");
    console.log(DashboardRoute);
    setLoggedIn && setLoggedIn(true);
    if (afterLoginRedirectUrl) {
      navigate(afterLoginRedirectUrl);
    } else {
      navigate(DashboardRoute);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group widths="equal">
        <Form.Field
          required={true}
          data-cy="impersonate-checkbox"
          control={Checkbox}
          label={<label>{t("impersonate.confirmation", { name })}</label>}
          checked={isChecked}
          onChange={() => setIsChecked(!isChecked)}
        />
      </Form.Group>
      <Form.Button data-cy="impersonate-submit" type="submit" disabled={!isChecked}>
        {t("impersonate.submitButton")}
      </Form.Button>
    </Form>
  );
}

export default Impersonate;
